import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const styles = {
  page: {
    minHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 14,
    padding: '2rem',
    background: '#0F172A',
    color: '#F8FAFC',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    textAlign: 'center',
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 64,
    height: 64,
    borderRadius: 16,
    background: 'rgba(124, 58, 237, 0.18)',
    color: '#C4B5FD',
    fontSize: 28,
    fontWeight: 700,
    marginBottom: 6,
  },
  title: { margin: 0, fontSize: '1.5rem', fontWeight: 700 },
  body: { margin: 0, color: '#94A3B8', maxWidth: 460, lineHeight: 1.5 },
  actions: { display: 'flex', gap: 12, marginTop: 8, flexWrap: 'wrap', justifyContent: 'center' },
  btn: {
    padding: '0.6rem 1.1rem',
    borderRadius: 10,
    background: '#7C3AED',
    color: '#fff',
    fontSize: '0.95rem',
    fontWeight: 600,
    textDecoration: 'none',
  },
  btnOutline: {
    padding: '0.6rem 1.1rem',
    borderRadius: 10,
    border: '1.5px solid #334155',
    background: 'transparent',
    color: '#94A3B8',
    fontSize: '0.95rem',
    fontWeight: 600,
    textDecoration: 'none',
  },
};

export default function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div style={styles.page} role="alert">
      <span style={styles.badge} aria-hidden="true">404</span>
      <h1 style={styles.title}>{t('pageNotFound.title')}</h1>
      <p style={styles.body}>{t('pageNotFound.body')}</p>
      <div style={styles.actions}>
        <Link to="/" style={styles.btn}>{t('pageNotFound.homeButton')}</Link>
        <a href="mailto:support@waitless.live" style={styles.btnOutline}>
          {t('pageNotFound.contactButton')}
        </a>
      </div>
    </div>
  );
}
